module.exports = __webpack_public_path__ + "img/zuankong_2.prt.21a5c097.jpg";